import { RES_DOMAIN } from "constant/config";
import {
    ADULT,
    ADULT_LOCK,
    AUTH_DENIED,
    BLIND,
    DELETE,
    ENCODING_FAIL,
    EXPIRE,
    LOADING,
    LOCK,
    SUCCEED,
    UPLOAD_FAIL,
} from "constant/ucc.thumb.type";
import { DEFAULT_THUMBNAIL_IMAGE_URL } from "listeners/error.listener";
import React, { useState, useMemo, useEffect } from "react";
import { Trans } from "react-i18next";

const VodImage = ({ vod, children, init}) => {
    const { thumb = "", thumb_type: thumbType = SUCCEED } = vod;
    
    const [imgError, setImgError] = useState(false);
    const handleVodImageError = (e) => {
        setImgError(true);
    };

    useEffect(() => {
        // vod 변경 시 state 강제로 초기화
        // 최초 load시에는 state, memo 모두 초기화 되어 thumbnail 정상 출력 > vod 변경 감지 event 가 없어 state init이 안 됨 (https://dev.to/cronokirby/react-pitfalls-usestate-initialization-39be)
        setImgError(false);
    }, [vod])

    const thumbnail = useMemo(() => {
        let vodThumb = thumb;

        if(typeof vodThumb === 'string') {
            vodThumb = vodThumb.replace(/(_r)/g, "_l");
        }

        // make 형으로 만들자 외부에서 한눈에 확인 가능
        return (
            <>
                <img src={vodThumb} alt="" onError={handleVodImageError} loading="lazy"/>
                {children ? children : null}
            </>
        )

	}, [children, thumb, vod.catchInfo, vod.file_type]);

    switch (thumbType) {
        case ENCODING_FAIL: // 인코딩 실패
            return(
                <span className="thumb-encoding">
                    <em><Trans>인코딩 실패</Trans></em>
                </span>
            );

        case UPLOAD_FAIL: // 업로드 실패
            return(
                <span className="thumb-upload">
                    <em><Trans>업로드 실패</Trans></em>
                </span>
            );
        case DELETE: // 어드민 삭제
            return(
                <span className="thumb-del">
                    <em>숲지기 삭제</em>
                </span>
            );
        case LOADING: // 로딩 중(변환 중)
            return(
                <span className="thumb-converting">
                    <em><Trans>VOD 변환중</Trans></em>
                </span>
            );
        case BLIND: // 블라인드 영상
            return (
                <span className="thumb-blind">
                    <em><Trans>블라인드</Trans></em>
                </span>
            );
        // 권한 없는 게시글
        case AUTH_DENIED:
            return <img src={DEFAULT_THUMBNAIL_IMAGE_URL} alt="" loading="lazy" />;

        // 기간 만료
        case EXPIRE:
            return <img src={`${RES_DOMAIN}/images/mobile/mybs/img_expire.jpg`} alt="" loading="lazy" />;

        // 19금 비공개
        case ADULT_LOCK:
            return (
                <span className="thumb-lock_adult">
                    <Trans>19금 + 비번방</Trans>
                </span>
            );

        // 비공개
        case LOCK:
            return (
                <span className="thumb-private">
                    비공개
                </span>
            );

        // 성인 영상
        case ADULT:
            return (
                <span className="thumb-adult">
                    <Trans>19금</Trans>
                </span>
            );

        // 완료 - 썸네일 노출
        case SUCCEED:
        default:
            if (imgError) {
                return (
                    <span className="thumb-default">
                        <Trans>썸네일</Trans>
                    </span>
                );
            } else { 
                return thumbnail
            }
    }
};

export default VodImage;
